import { createListStore } from '@/store/list-state.factory';

export const useMembersListStore = createListStore('members-list-state');
